module.exports = "/ui/bfc67c289898f6500bff218b52293138.png";